/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DailyScoreResponseSub } from '../models';
// @ts-ignore
import type { GetUserActivityResponse } from '../models';
// @ts-ignore
import type { GetUserContributionActivityResponse } from '../models';
/**
 * ScoreApiApi - axios parameter creator
 */
export const ScoreApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} [endDate] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreApiGetDailyScoreDataByDateRange: async (userId: string, endDate?: string, startDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('scoreApiGetDailyScoreDataByDateRange', 'userId', userId)
            const localVarPath = `/score/{user_id}/daily_statistics`
                .replace('{user_id}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [selectedMonth] 
         * @param {string} [selectedYear] 
         * @param {string} [summaryType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreApiGetUserContributionActivity: async (username: string, selectedMonth?: string, selectedYear?: string, summaryType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('scoreApiGetUserContributionActivity', 'username', username)
            const localVarPath = `/{username}/get-user-contribution-activity`
                .replace('{username}', encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (selectedMonth !== undefined) {
                localVarQueryParameter['selected_month'] = selectedMonth;
            }

            if (selectedYear !== undefined) {
                localVarQueryParameter['selected_year'] = selectedYear;
            }

            if (summaryType !== undefined) {
                localVarQueryParameter['summary_type'] = summaryType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [selectedMonth] 
         * @param {string} [selectedYear] 
         * @param {string} [summaryType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreApiGetUserDailyActivity: async (username: string, selectedMonth?: string, selectedYear?: string, summaryType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('scoreApiGetUserDailyActivity', 'username', username)
            const localVarPath = `/{username}/get-user-activity`
                .replace('{username}', encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (selectedMonth !== undefined) {
                localVarQueryParameter['selected_month'] = selectedMonth;
            }

            if (selectedYear !== undefined) {
                localVarQueryParameter['selected_year'] = selectedYear;
            }

            if (summaryType !== undefined) {
                localVarQueryParameter['summary_type'] = summaryType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScoreApiApi - functional programming interface
 */
export const ScoreApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScoreApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} userId 
         * @param {string} [endDate] 
         * @param {string} [startDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreApiGetDailyScoreDataByDateRange(userId: string, endDate?: string, startDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyScoreResponseSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreApiGetDailyScoreDataByDateRange(userId, endDate, startDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoreApiApi.scoreApiGetDailyScoreDataByDateRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [selectedMonth] 
         * @param {string} [selectedYear] 
         * @param {string} [summaryType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreApiGetUserContributionActivity(username: string, selectedMonth?: string, selectedYear?: string, summaryType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserContributionActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreApiGetUserContributionActivity(username, selectedMonth, selectedYear, summaryType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoreApiApi.scoreApiGetUserContributionActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} username 
         * @param {string} [selectedMonth] 
         * @param {string} [selectedYear] 
         * @param {string} [summaryType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scoreApiGetUserDailyActivity(username: string, selectedMonth?: string, selectedYear?: string, summaryType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserActivityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scoreApiGetUserDailyActivity(username, selectedMonth, selectedYear, summaryType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ScoreApiApi.scoreApiGetUserDailyActivity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ScoreApiApi - factory interface
 */
export const ScoreApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScoreApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ScoreApiApiScoreApiGetDailyScoreDataByDateRangeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreApiGetDailyScoreDataByDateRange(requestParameters: ScoreApiApiScoreApiGetDailyScoreDataByDateRangeRequest, options?: RawAxiosRequestConfig): AxiosPromise<DailyScoreResponseSub> {
            return localVarFp.scoreApiGetDailyScoreDataByDateRange(requestParameters.userId, requestParameters.endDate, requestParameters.startDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ScoreApiApiScoreApiGetUserContributionActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreApiGetUserContributionActivity(requestParameters: ScoreApiApiScoreApiGetUserContributionActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserContributionActivityResponse> {
            return localVarFp.scoreApiGetUserContributionActivity(requestParameters.username, requestParameters.selectedMonth, requestParameters.selectedYear, requestParameters.summaryType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ScoreApiApiScoreApiGetUserDailyActivityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scoreApiGetUserDailyActivity(requestParameters: ScoreApiApiScoreApiGetUserDailyActivityRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserActivityResponse> {
            return localVarFp.scoreApiGetUserDailyActivity(requestParameters.username, requestParameters.selectedMonth, requestParameters.selectedYear, requestParameters.summaryType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for scoreApiGetDailyScoreDataByDateRange operation in ScoreApiApi.
 */
export interface ScoreApiApiScoreApiGetDailyScoreDataByDateRangeRequest {
    readonly userId: string

    readonly endDate?: string

    readonly startDate?: string
}

/**
 * Request parameters for scoreApiGetUserContributionActivity operation in ScoreApiApi.
 */
export interface ScoreApiApiScoreApiGetUserContributionActivityRequest {
    readonly username: string

    readonly selectedMonth?: string

    readonly selectedYear?: string

    readonly summaryType?: string
}

/**
 * Request parameters for scoreApiGetUserDailyActivity operation in ScoreApiApi.
 */
export interface ScoreApiApiScoreApiGetUserDailyActivityRequest {
    readonly username: string

    readonly selectedMonth?: string

    readonly selectedYear?: string

    readonly summaryType?: string
}

/**
 * ScoreApiApi - object-oriented interface
 */
export class ScoreApiApi extends BaseAPI {
    /**
     * 
     * @param {ScoreApiApiScoreApiGetDailyScoreDataByDateRangeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public scoreApiGetDailyScoreDataByDateRange(requestParameters: ScoreApiApiScoreApiGetDailyScoreDataByDateRangeRequest, options?: RawAxiosRequestConfig) {
        return ScoreApiApiFp(this.configuration).scoreApiGetDailyScoreDataByDateRange(requestParameters.userId, requestParameters.endDate, requestParameters.startDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ScoreApiApiScoreApiGetUserContributionActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public scoreApiGetUserContributionActivity(requestParameters: ScoreApiApiScoreApiGetUserContributionActivityRequest, options?: RawAxiosRequestConfig) {
        return ScoreApiApiFp(this.configuration).scoreApiGetUserContributionActivity(requestParameters.username, requestParameters.selectedMonth, requestParameters.selectedYear, requestParameters.summaryType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ScoreApiApiScoreApiGetUserDailyActivityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public scoreApiGetUserDailyActivity(requestParameters: ScoreApiApiScoreApiGetUserDailyActivityRequest, options?: RawAxiosRequestConfig) {
        return ScoreApiApiFp(this.configuration).scoreApiGetUserDailyActivity(requestParameters.username, requestParameters.selectedMonth, requestParameters.selectedYear, requestParameters.summaryType, options).then((request) => request(this.axios, this.basePath));
    }
}

